import 'utils/polyfills';
import React, { StrictMode } from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router';
import { createBrowserHistory } from 'history';
//import ReactGA from 'react-ga';

import LanguageProvider from 'jsx/locale/LanguageProviderV2';
import AuthProvider from 'jsx/auth/AuthProviderV2';
import ScrollToTop from 'jsx/layout/ScrollToTopV2';

import './main.less';
import { App } from 'components/App';

const history = createBrowserHistory();

// Google analytics - need new id
//if (process.env.REACT_APP_USE_ANALYTICS === 'yes') {
//  ReactGA.initialize('UA-56354358-4', { debug: false, titleCase: false });
//  history.listen(location => ReactGA.pageview(location.pathname + location.search));
//}
// LoanFreezeWeb
// LoanFreezeWebClient2020
const authConfig = {
  authUrl: process.env.REACT_APP_STS_URL,
  clientId: 'WebBusiness',
  scope: 'openid profile creditinfo sharedapi webbusiness offline_access  webloanfreezeapi ',
  secret: 'WebBusinessClientAccessKey2017'
};

render(
  <StrictMode>
    <AuthProvider authConfig={authConfig} history={history} restrict>
      <Router history={history}>
        <LanguageProvider>
          <ScrollToTop />
          <App />
        </LanguageProvider>
      </Router>
    </AuthProvider>
  </StrictMode>,
  document.getElementById('root')
);
